<template>
  <div class="dialog-container">
    <div class="el-form-item">
      <label class="el-form-item__label">Selected Docutax Client</label>
      <el-select size="small" disabled style="width: 100%" :value="docutaxClient.id">
        <el-option :key="docutaxClient.id" :label="clientDisplayLabel" :value="docutaxClient.id" />
      </el-select>
    </div>
    <el-form size="small" :model="form" status-icon :rules="validationRules" ref="requestForm">
      <el-form-item label="Office" required prop="officeId">
        <el-select style="width: 100%" v-model="form.officeId" :clearable="false" placeholder="Select Office">
          <el-option v-for="item in allUserOffices" :key="item.id" :label="convertOfficeToRefType(item).name"
            :value="item.id">
          </el-option>
        </el-select>
      </el-form-item>
      <el-form-item label="Message" required prop="message">
        <el-input v-model="form.message" type="textarea" maxlength="500" :autosize="{ minRows: 3, maxRows: 6 }"
          placeholder="Include a message to your client" />
      </el-form-item>
      <docutax-request-message-template :docutax-client="docutaxClient" @change="onTemplateChange"
        @clear="onTemplateClear" />
      <el-row type="flex" justify="center">
        <el-button v-loading="saving" class="ma-3" type="primary" round @click="onSubmit">Send Request</el-button>
      </el-row>
    </el-form>
  </div>
</template>

<script>
import { mapGetters } from 'vuex';
import api from '@/api';
import { DocutaxClient } from '@/model';
import DocutaxRequestMessageTemplate from '@/components/form-item/DocutaxRequestMessageTemplate.vue';
import OfficeToRefType from '@/util/OfficeToRefType';

export default {
  name: 'DocutaxRequestForClientDialog',
  components: {
    DocutaxRequestMessageTemplate,
  },
  props: {
    docutaxClient: {
      type: Object,
      required: true,
    },
  },
  data() {
    return {
      saving: false,
      form: {
        client: new DocutaxClient(),
        message: '',
        officeId: undefined,
      },
      validationRules: {
        officeId: [{ required: true, message: 'Office is required', trigger: 'change' }],
        message: [{ required: true, message: 'Message is required', trigger: 'blur' }],
      },
    };
  },
  watch: {
    docutaxClient: {
      immediate: true,
      handler(val) {
        if (val) {
          this.form.client = new DocutaxClient(val);
          this.form.officeId = val.selectedOfficeId;
        }
      },
    },
  },
  computed: {
    ...mapGetters('User', ['allUserOffices']),
    clientDisplayLabel() {
      if (!this.docutaxClient) return '';
      const name = [this.docutaxClient.firstName, this.docutaxClient.lastName]
        .filter(part => !!part && part.length)
        .join(' ');
      return [name, this.docutaxClient.cellPhone, this.docutaxClient.emailAddress]
        .filter(part => !!part && part.length)
        .join(' - ');
    },
  },
  methods: {
    convertOfficeToRefType(office) {
      return OfficeToRefType(office);
    },
    async onSubmit() {
      try {
        await this.$refs.requestForm.validate();
      } catch (e) {
        return;
      }

      try {
        this.saving = true;
        const response = await api.docutaxRequests.create(this.form);
        if (response.data) {
          this.$emit('requestSent');
          this.onClose();
        } else {
          throw new Error('An unknown error occurred');
        }
      } catch (e) {
        console.error('An error occurred while sending docutax request', e);
        let message = e.message;
        if (e.response && e.response.data) {
          message = e.response.data;
        }
        this.$message.error(`Failed to send docutax request - ${message}`);
      } finally {
        this.saving = false;
      }
    },
    onTemplateChange(templateContent) {
      this.form.message = templateContent;
    },
    onTemplateClear() {
      this.form.message = '';
    },
    onClose() {
      this.$refs.requestForm.resetFields();
      this.$emit('close');
    },
  },
};
</script>
